import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import DolarIcon from "../../assets/images/dolar.svg";
import PaperIcon from "../../assets/images/paper.svg";
import SignIcon from "../../assets/images/sign.svg";
import CoinIcon from "../../assets/images/coin.svg";
import PhoneImage from "../../assets/images/telas.svg";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  margin-top: -180px;
`;

const TitleCard = styled.span`
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
`;

const SubtitleCard = styled.span`
  font-weight: 300;
  font-size: 16px;
  line-height: 30px;
`;

const Card = styled.div<{ left: boolean }>`
  background-color: #e8f8ff;
  color: #1e1e1e;
  padding: 70px 90px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 55px;
  }
`;

const ImagePhone = styled.img`
  width: 100%;
  max-width: 400px;
  margin: 40px auto;

  @media (min-width: 576px) {
    width: 90%;
    max-width: 450px;
  }

  @media (min-width: 992px) {
    width: 100%;
    max-width: 500px;
    margin-top: 0;
  }
`;

const ContainerDiv = styled.div`
  border-left: 2px solid #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;

  @media (min-width: 768px) {
    gap: 80px;
  }

  @media (min-width: 992px) {
    gap: 100px;
  }
`;

const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
  left: -11px;

  @media (min-width: 768px) {
    gap: 20px;
    left: -12px;
  }
`;

const CircleDiv = styled.div`
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CircleIntoDiv = styled.div`
  width: 12px;
  height: 12px;
  background-color: #4162fd;
  border-radius: 12px;
`;

const BodyTexts = styled.div`
  color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
`;

const TitleItemList = styled.span<{left: boolean}>`
  font-weight: 800;
  font-size: 180px;
  color: #4162fd20;
  line-height: 135px;
  font-style: italic;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  ${({left}) => {
    if(left) {
      return `
        left: -80px;
      `
    } else {
      return `
        right: -50px;
      `
    }
  }}

  @media (max-width: 768px) {
    font-size: 100px;
    line-height: 85px;

    ${({left}) => {
    if(left) {
      return `
        left: -55px;
      `
    } else {
      return `
        right: -35px;
      `
    }
  }}
  }
`;

const SubtitleItemList = styled.span`
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 30px;
  }
`;

const cardData = [
  {
    title: "Cobranças automatizadas",
    subtitle: "Receba os aluguéis via PIX, sem complicações.",
    icon: DolarIcon,
    iconWidth: "40px",
  },
  {
    title: "Contratos rápidos",
    subtitle: "Crie contratos personalizados em minutos para cada imóvel.",
    icon: PaperIcon,
    iconWidth: "30px",
  },
  {
    title: "Assinatura digital",
    subtitle: "Validade jurídica garantida, 100% digital e segura.",
    icon: SignIcon,
    iconWidth: "80px",
  },
  {
    title: "Gestão de pagamentos",
    subtitle: "Tenha controle total dos pagamentos, em qualquer lugar.",
    icon: CoinIcon,
    iconWidth: "40px",
  },
];

const About = () => {
  return (
    <Container style={{ textAlign: "center" }} id="section-2" full>
      <Title>
        Motivos para usar o <span style={{ color: "#4162FD" }}>Room</span>
      </Title>
      <Row
        gap="8px"
        xs="1fr"
        sm="1fr"
        md="1fr"
        lg="1fr 1fr"
        xl="1fr 1fr"
        style={{ marginTop: "40px" }}
      >
        {cardData.map((card, index) => (
          <Card key={index} left={index % 2 === 1}>
            <Row
              xs={index % 2 === 1 ? "auto" : "auto"}
              sm={index % 2 === 1 ? "auto" : "auto"}
              md={index % 2 === 1 ? "auto" : "auto"}
              lg={index % 2 === 1 ? "auto" : "auto"}
              xl={index % 2 === 1 ? "auto" : "auto"}
              style={{ textAlign: index % 2 === 1 ? 'left' : 'right', position: "relative", zIndex: 1 }}
              gap="0px"
            >
              {index % 2 === 1 && (
                <TitleItemList left>{index + 1}</TitleItemList>
              )}
              <div>
                <TitleCard>{card.title}</TitleCard>
                <br />
                <SubtitleCard>{card.subtitle}</SubtitleCard>
              </div>
              {index % 2 === 0 && (
                <TitleItemList left={false}>{index + 1}</TitleItemList>
              )}
            </Row>
          </Card>
        ))}
      </Row>
      <br />
    </Container>
  );
};

export default About;
